export function canSwitchMode(mode) {
    return true;
}
//# sourceMappingURL=view-mode.js.map


//////////////////
// WEBPACK FOOTER
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/~/ngx-bootstrap/datepicker/engine/view-mode.js
// module id = ../../../../ngx-bootstrap/datepicker/engine/view-mode.js
// module chunks = 8